import React from 'react'
import Link from 'next/link'
import { useRouter } from 'next/router'
import PropTypes from 'prop-types'
import useTranslation from 'next-translate/useTranslation'
import ReactSVG from 'react-svg'

import translations from '../../../../../../public/data/translations.json'

export const PartsItem = () => {
  const { t, lang } = useTranslation('common')
  const locale = lang?.toUpperCase() || 'ME'

  const activeItemRef = React.useRef(null)

  const router = useRouter()
  const isActive = ['/vehicleParts', '/vehiclePartsSearch'].includes(router?.pathname)

  React.useEffect(() => {
    if (isActive) {
      const container = document.querySelector('.category-horizontal-menu-mobile-items')
      if (activeItemRef && activeItemRef.current && container) {
        container.scrollTo(activeItemRef.current.offsetLeft, 0)
      }
    }
  }, [])

  return (
    <Link
      href={{
        pathname: '/vehicleParts',
        query: {
          group: translations['auto-djelovi'][locale].gume.slug, locale: lang
        }
      }}
      as={`/${translations.noviDjeloviUrl[locale]}/${translations['auto-djelovi'][locale].gume.slug}`}
    >
      <a ref={isActive ? activeItemRef : null} className={`category-horizontal-menu-mobile-item${isActive ? ' active' : ''}`} style={{ position: 'relative' }}>

        <span
          style={{
            position: 'absolute',
            right: 'auto',
            left: 'auto',
            backgroundColor: '#e91c23',
            color: '#fff',
            padding: '2px 5px',
            fontSize: '0.75rem',
            borderRadius: '3px',
            zIndex: 2,
            top: 0
          }}
        >
          {t('Novo').toUpperCase()}
        </span>
        <ReactSVG
          src='https://slike.autodiler.me/shop/gume.svg'
          beforeInjection={svg => {
            svg.setAttribute('style', 'width: 45px; max-height: 45px; margin: 0; position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);')
          }}
          wrapper='span'
          className='svg-container'
        />

        <p style={{ textTransform: 'uppercase' }}>{translations['auto-djelovi'][locale].gume.title}</p>
      </a>
    </Link>
  )
}
